import apiClient from '.';
import { setLoading } from '@/plugins/loading';

export const fetchDevicesFromAPI = async params => {
    try {
        const response = await apiClient.get('/iot/devices', { params });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const exportDevicesFromAPI = async (params = {}, type = 'csv') => {
    try {
        if (localStorage.getItem('locale') !== undefined) {
            params.output_language = localStorage.getItem('locale');
        }
        const response = await apiClient.get(`/iot/devices/export/${type}`, {
            params,
            responseType: 'blob',
        });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const fetchConfig = async () => {
    try {
        setLoading(true);
        const response = await apiClient.get('/iot/devices/configs');
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    } finally {
        setLoading(false);
    }
};

export const getDevice = async id => {
    try {
        const response = await apiClient.get(`/iot/devices/${id}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const deleteDevice = async psn => {
    try {
        const response = await apiClient.delete(`/iot/devices/${psn}`);
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// Reserved APIs for Add device modal

// Expected response: { code: '123456' }
export const generateRegistrationCode = async () => {
    try {
        const response = await apiClient.post(
            '/iot/devices/registration-codes'
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

// Expected response: { data: 'data:image/png;base64,...' }
export const generateQRCode = async () => {
    try {
        const response = await apiClient.post('/iot/devices/qr-codes');
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
